import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SiteBrandingContext = createContext();

export const useSiteBranding = () => {
  const context = useContext(SiteBrandingContext);
  if (!context) {
    throw new Error('useSiteBranding must be used within SiteBrandingProvider');
  }
  return context;
};

export const SiteBrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState({
    site_title: 'ESMC Network',
    logo_url: null,
    banner_url: null,
    logo_bg_color: '#000000'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBranding();
  }, []);

  const fetchBranding = async () => {
    try {
      const response = await axios.get(`${API}/settings/branding`);
      setBranding(response.data);
    } catch (error) {
      console.error('Failed to fetch site branding:', error);
    } finally {
      setLoading(false);
    }
  };

  const refreshBranding = () => {
    fetchBranding();
  };

  return (
    <SiteBrandingContext.Provider value={{ branding, loading, refreshBranding }}>
      {children}
    </SiteBrandingContext.Provider>
  );
};
